import { styles } from "./IntentSurveyPanel.style";
import { SelectionCard } from "./components/SelectionCard";
import { Button } from "../../elements/Button";
import { Icon, Icons } from "../../elements/Icon";

export interface IntentOption {
  id: string;
  value: string;
  icon: string;
  description: string;
}

export interface IntentSurveyPanelProps {
  headline: string;
  options: IntentOption[];
  selectedValue: string | undefined;
  onSelect: (value: string) => void;
  onContinue: () => void;
  continueLabel: string;
  mascotSrc?: string;
  mascotAlt?: string;
  errorMessage?: string;
  showError?: boolean;
}

export const IntentSurveyPanel = ({
  headline,
  options,
  selectedValue,
  onSelect,
  onContinue,
  continueLabel,
  mascotSrc,
  mascotAlt = "",
  errorMessage,
  showError = false,
}: IntentSurveyPanelProps) => {
  return (
    <section className={styles.wrapper()} aria-labelledby="intent-survey-headline">
      <div className={styles.header()}>
        <div className={styles.headerTop()}>
          <h1 id="intent-survey-headline" className={styles.headline()}>
            {headline}
          </h1>
          {mascotSrc && (
            <div className={styles.mascotWrapper()}>
              <img src={mascotSrc} alt={mascotAlt} className={styles.mascotImage()} />
            </div>
          )}
        </div>
      </div>

      <div className={styles.cardList()} role="radiogroup" aria-labelledby="intent-survey-headline">
        {options.map((option) => (
          <SelectionCard
            key={option.id}
            id={option.id}
            name="intent-question"
            icon={option.icon}
            description={option.description}
            isSelected={selectedValue === option.value}
            onChange={() => onSelect(option.value)}
          />
        ))}
      </div>

      <div className={styles.footer()}>
        {errorMessage && showError && !selectedValue && (
          <p className={styles.errorMessage()} role="alert">
            {errorMessage}
          </p>
        )}
        <Button
          onClick={onContinue}
          disabled={!selectedValue}
          testSelector="intent-survey-continue-button"
          ariaLabel={continueLabel}
        >
          {continueLabel}
          <Icon icon={Icons.arrowForward2} size={16} />
        </Button>
      </div>
    </section>
  );
};

IntentSurveyPanel.displayName = "IntentSurveyPanel";
